import versionInfo from './version.json';

interface GoogleConfig {
  API_KEY: string;
  CLIENT_ID: string;
  SECRET: string;
}

interface FacebookConfig {
  APP_ID: string;
}

interface ApiConfig {
  API_URL: string;
  BASE_URL?: string;
}

interface Config {
  google: GoogleConfig;
  facebook: FacebookConfig;
  api: ApiConfig;
  app: {
    version: string;
    name: string;
    environment: string;
  };
}

// Dynamically determine API URL based on current location
const getApiUrl = () => {
  // If environment variable is set, use it
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  // In production builds or when accessed via network
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    // For production domains (like beta.mxr.space), use the domain without port
    if (window.location.hostname.includes('mxr.space')) {
      return `${window.location.protocol}//${window.location.hostname}/api`;
    }
    // For IP addresses or other hostnames, keep using port 3000
    return `http://${window.location.hostname}:3000/api`;
  }
  
  // Default to localhost for local development
  return "http://localhost:3000/api";
};

const getBaseUrl = () => {
  // If environment variable is set, use it
  if (import.meta.env.VITE_BASE_URL) {
    return import.meta.env.VITE_BASE_URL;
  }
  
  // In production builds or when accessed via network
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    // For production domains (like beta.mxr.space), use the domain without port
    if (window.location.hostname.includes('mxr.space')) {
      return `${window.location.protocol}//${window.location.hostname}`;
    }
    // For IP addresses or other hostnames, keep using port 3000
    return `http://${window.location.hostname}:3000`;
  }
  
  // Default to localhost for local development
  return "http://localhost:3000";
};

const config: Config = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: getApiUrl(),
    BASE_URL: getBaseUrl(),
  },
  app: {
    version: import.meta.env.MODE === 'production' 
      ? versionInfo.currentVersion 
      : `${versionInfo.currentVersion}-dev`,
    name: 'MXR Space Admin',
    environment: import.meta.env.MODE || 'development',
  },
};

export default config;